var _defs, _path, _line, _line2, _rect, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 79.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#5656ff;}.cls-1,.cls-2,.cls-3{stroke:#5656ff;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-2{stroke-width:2.28px;}.cls-2{fill:none;}.cls-3{stroke-width:2.86px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.53,72.42V61.17a3.86,3.86,0,0,0-3.86-3.85H16.33a3.86,3.86,0,0,0-3.86,3.85V72.42"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.88,
    y1: 56.55,
    x2: 16.88,
    y2: 32.23
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.69,
    y1: 56.55,
    x2: 62.69,
    y2: 32.23
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.47,
    y: 20.42,
    width: 55.06,
    height: 11.81
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.35,56.92V52.18s.28-4.74,6.79-4.74,6.51,5.37,6.51,5.37v4.11"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 40,
    cy: 41.25,
    r: 3.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpo);
export default __webpack_public_path__ + "static/media/Icon-expo.1004afd579d82cbd75a40dbd24cdd4c2.svg";
export { ForwardRef as ReactComponent };